<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-capitalize">Conversion</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">Reports</li>
              <li class="breadcrumb-item active text-capitalize">
                <i class="fas fa-list"></i> Conversion
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="container-fluid">
        <data-table-wrapper
            ref="dataTable"
            :columns="columns"
            :filters="filters"
            :load-data-callback="loadDataCallback"
            :filter-defaults="filterDefaults"
            disable-primary-column="true"
            disable-edit-action="true"
            disable-delete-action="true"
            :disable-auto-load="true"
            endpoint="/conversion-report"
            api-service="analytics"
        >
          <template v-slot:filter-buttons>
            <button class="btn btn-default float-right" @click="doExport">
              <span v-if="!exportInProgress">
                  <i class="fa fa-cloud-download"></i> {{ $t('Export') }}
              </span>
              <span v-else>
                  <i class="fas fa-spinner fa-pulse"></i> {{ $t('Export') }}
              </span>
            </button>
          </template>
        </data-table-wrapper>
      </div>
    </section>
  </div>
</template>

<script>
import DataTableWrapper from '../components/DataTableWrapper';
import {mapGetters} from "vuex";
import * as dateUtils from "@/helpers/dateUtils";

export default {
  components: {
    DataTableWrapper
  },
  data() {
    return {
      exportInProgress: false,
      loadDataCallback: (component, respData) => {
        component.items = respData;
        component.pagination.onPage = component.pagination.total = component.items.length;
        component.pagination.page = 1;
        component.showEmpty = true;
      },
      filters: [
        {
          field: 'fromDate',
          placeholder: 'From Date',
          label: 'From Date',
          type: 'date-picker',
          shortcuts: dateUtils.getFilterShortcuts()
        },
        {
          field: 'toDate',
          placeholder: 'To Date',
          label: 'To Date',
          type: 'date-picker',
          shortcuts: dateUtils.getFilterShortcuts()
        },
        {
          field: 'gameIds',
          placeholder: 'Select games',
          label: 'Games',
          type: 'multiselect',
          optionLabel: 'name',
          multiple: true,
          getValue: (games) => { return games ? games.map(game => game.id) : [] },
          getOptions: () => this.getGames,
          trackBy: 'id'
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'getGames',
      'getGame',
    ]),
    filterDefaults() {
      return {
        fromDate: dateUtils.getTodayDate(),
      };
    },
    columns() {
      return [
        {
          field: 'game_id',
          title: 'Game',
          sorting: false,
          callback: ({row}) => {
            const game = this.getGame(row.game_id) || this.getGame(String(row.game_id));
            return game ? game.name : row.game_id;
          },
        },
        {
          field: 'total_sessions',
          title: 'Total Sessions',
          sorting: false,
        },
        {
          field: 'didnt_loaded',
          title: "Didn't Load",
          sorting: false,
        },
        {
          field: 'didnt_loaded_percent',
          title: "Didn't Load %",
          sorting: false,
          callback: ({row}) => row.didnt_loaded_percent != null ? row.didnt_loaded_percent + '%' : '',
        },
        {
          field: 'loaded',
          title: 'Loaded',
          sorting: false,
        },
        {
          field: 'loaded_percent',
          title: 'Loaded %',
          sorting: false,
          callback: ({row}) => row.loaded_percent != null ? row.loaded_percent + '%' : '',
        },
        {
          field: 'loaded_but_was_nospin',
          title: 'Loaded, No Spin',
          sorting: false,
        },
        {
          field: 'loaded_but_was_nospin_percent',
          title: 'Loaded, No Spin %',
          sorting: false,
          callback: ({row}) => row.loaded_but_was_nospin_percent != null ? row.loaded_but_was_nospin_percent + '%' : '',
        },
        {
          field: 'has_only_one_spin',
          title: 'Only 1 Spin',
          sorting: false,
        },
        {
          field: 'has_only_one_spin_percent',
          title: 'Only 1 Spin %',
          sorting: false,
          callback: ({row}) => row.has_only_one_spin_percent != null ? row.has_only_one_spin_percent + '%' : '',
        },
        {
          field: 'has_spins',
          title: 'Has Spins',
          sorting: false,
        },
        {
          field: 'has_spins_percent',
          title: 'Has Spins %',
          sorting: false,
          callback: ({row}) => row.has_spins_percent != null ? row.has_spins_percent + '%' : '',
        },
      ];
    },
  },
  methods: {
    doExport() {
      if (this.exportInProgress) {
        return;
      }
      this.exportInProgress = true;
      this.$exportService.doExport('conversion-report', this.$refs.dataTable.getPageQuery()).finally(() => {
        this.exportInProgress = false;
      });
    },
  },
}
</script>
